// @ts-check
import apiClient from "./apiClient";

/**
 * @param {{ limit?: number; offset?: number; sort?: string }} params
 * @returns {Record<string, any>}
 */
const buildListParams = (params = {}) => {
  const result = {};
  if (params.limit !== undefined) result.limit = params.limit;
  if (params.offset !== undefined) result.offset = params.offset;
  if (params.sort !== undefined) result.sort = params.sort;
  return result;
};

/**
 * @param {number} requirementId
 * @param {{ limit?: number; offset?: number; sort?: string }} params
 * @returns {Promise<import("./types").PaginatedResponse<import("./types").ControlRead>>}
 */
export async function getMappedControls(requirementId, params = {}) {
  const response = await apiClient.get(`/requirements/${requirementId}/controls`, {
    params: buildListParams(params),
  });
  return response.data;
}

/**
 * @param {number} requirementId
 * @param {number[]} controlIds
 * @returns {Promise<import("./types").MappingSummary>}
 */
export async function bulkAddControls(requirementId, controlIds) {
  const response = await apiClient.post(`/requirements/${requirementId}/controls`, {
    control_ids: controlIds,
  });
  return response.data;
}

/**
 * @param {number} requirementId
 * @param {number} controlId
 * @returns {Promise<void>}
 */
export async function removeControlMapping(requirementId, controlId) {
  await apiClient.delete(`/requirements/${requirementId}/controls/${controlId}`);
}
